import React, { useEffect } from "react";
import { callAPI } from "@/react/lib/common";

export const GreenScreenBackgroundsContext = React.createContext(null);

const GreenScreenBackgroundProvider = ({ children, jobUuid }) => {
  const [loading, setLoading] = React.useState(false);
  const [backgrounds, setBackgrounds] = React.useState([]);

  useEffect(() => {
    const handleJobUuidUpdate = async (jobUuid) => {
      if (!jobUuid) {
        return;
      }
      setLoading(true);
      try {
        const bgs = await callAPI(
          "/api/webshop/green-screen-backgrounds/" + jobUuid,
        );
        setBackgrounds(bgs);
      } catch (err) {
        console.log("Error", err);
      } finally {
        setLoading(false);
      }
    };

    handleJobUuidUpdate(jobUuid);
  }, [jobUuid]);

  return (
    <GreenScreenBackgroundsContext.Provider value={[backgrounds, loading]}>
      {children}
    </GreenScreenBackgroundsContext.Provider>
  );
};

export const useGreenScreenBackgrounds = () => {
  const context = React.useContext(GreenScreenBackgroundsContext);
  if (!context) {
    throw Error(
      "useGreenscreenBackgrounds must be used inside a GreenScreenBackgroundsProvider",
    );
  }
  return context;
};

export default GreenScreenBackgroundProvider;
